import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Messages} from '../model/messages';
import {Message} from '../model/message';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {MatExpansionPanel} from '@angular/material/expansion';

@Component({
  selector: 'app-sub-messages',
  templateUrl: './sub-messages.component.html',
  styleUrls: ['./sub-messages.component.css']
})
export class SubMessagesComponent implements OnInit {

  @Input()
  data: Messages;
  show = false;

  @ViewChild('panel') panel: MatExpansionPanel;

  @Output()
  onGroupDeleted = new EventEmitter<string>();

  constructor(
      private appService: AppService,
      private translate: TranslateService,
      private http: HttpClient
  ) {}

  ngOnInit() {
  }

  headerClick() {
    this.show = !this.show;
  }

  afterMessageDeleted(m: Message) {
    this.data.messages = this.data.messages.filter(i => i.id !== m.id);
  }

  deleteAll($event: MouseEvent)
  {
    $event.stopPropagation();

    const message = this.translate.instant('Zmazať všetky notifikácie v skupine') + ' "' + this.data.key + '"?';

    const ids = this.data.messages.map(i => i.id);

    this.appService.openConfirmDialog(message)
        .subscribe((res) => {
          if ('OK' === res) {
            this.http
                .post('/ais/rest/portal/messages/delete-bulk', ids)
                .subscribe(
                    () => {
                      this.onGroupDeleted.next(this.data.key);
                    }
                );
          }
        });
  }

  get25(key: string) {
    if (key.length > 25) {
      return key.substring(0, 25) + '...';
    }
    return key;
  }

  isPanelExpanded() {
    if (this.panel) {
      return this.panel.expanded;
    }
    return false;
  }
}
